'use client';
import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';

function ScrollToTop() {
  const [showButton, setShowButton] = useState<boolean>(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  return (
    <div
      className={`fixed bottom-5 right-[-50px] transition-transform transform duration-500 
    ${showButton ? 'translate-x-[-60px]' : 'translate-x-0'} z-50`}
    >
      <button
        onClick={scrollToTop}
        className="bg-white p-3 rounded-full shadow-lg hover:bg-colorMain-dark text-colorMain"
      >
        <FaArrowUp className="h-3 w-3 md:h-5 md:w-5" />
      </button>
    </div>
  );
}

export default ScrollToTop;
